import type {Editor} from 'grapesjs';
import {getAllColorHexesInComponent} from '@EmailMakerReact/lib/email-maker-component-query-library';

/**
 * Distinct `#RRGGBB` colors used anywhere in the email (color / background-color / border-color across the
 * whole component tree), deduped and sorted. Reuses the shared component-tree color walk so it can feed the
 * color picker's "On my email" swatches.
 */
export function getEmailColorsInUse(editor: Editor): string[] {
  const wrapper = editor.getWrapper();
  if (!wrapper) {
    return [];
  }
  const hexes = getAllColorHexesInComponent(wrapper).map((hex) => `#${hex.toUpperCase()}`);
  return Array.from(new Set(hexes)).sort();
}
